export function randomPassword() {
  const part1 = Math.random().toString(36).slice(2, 5)
  const part2 = Math.random().toString(36).slice(2, 8)
  return `${part1}.${part2}`
}
